module.exports = __webpack_public_path__ + "static/connections-logo-079ce8efc7a4a4df6cf5311846968cfe.png";